import { all, takeEvery, put, fork, call, takeLatest } from "redux-saga/effects";
import { resourceSheetService } from "@iso/services";
import actions from "./actions";

function* getListResourceSheet() {
  yield takeEvery(actions.GET_LIST_RESOURCE_SHEET, function* ({ payload }) {
    try {
      const result = yield call(resourceSheetService.fetchResourceSheets, payload);
      yield put({
        type: actions.GET_LIST_RESOURCE_SHEET_SUCCESS,
        rows: result ? result.rows : [],
        total: result ? result.total : 0,
        taskTotal: result ? result.taskTotal || 0 : 0,
        summaryRowCount: result ? result.summaryRowCount || 0 : 0,
        plannedHours: result ? result.plannedHours || [] : [],
        holdHours: result ? result.holdHours || [] : [],
        doTimesheetHoursByDay: result ? result.doTimesheetHoursByDay || {} : {},
        checkTimesheetHoursByDay: result ? result.checkTimesheetHoursByDay || {} : {},
        doRemainingHoursByDay: result ? result.doRemainingHoursByDay || {} : {},
        checkRemainingHoursByDay: result ? result.checkRemainingHoursByDay || {} : {},
      });
    } catch (e) {
      yield put({ type: actions.GET_LIST_RESOURCE_SHEET_ERROR, error: e });
    }
  });
}

function* appendResourceSheetWeek() {
  yield takeEvery(actions.APPEND_RESOURCE_SHEET_WEEK, function* ({ payload }) {
    const { resolve, reject, ...requestPayload } = payload;
    try {
      const result = yield call(
        resourceSheetService.fetchResourceSheets,
        requestPayload
      );
      yield put({
        type: actions.APPEND_RESOURCE_SHEET_WEEK_SUCCESS,
        plannedHours: result ? result.plannedHours || [] : [],
        holdHours: result ? result.holdHours || [] : [],
      });
      if (resolve) {
        yield resolve(result);
      }
    } catch (e) {
      yield put({ type: actions.APPEND_RESOURCE_SHEET_WEEK_ERROR, error: e });
      if (reject) {
        reject(e);
      }
    }
  });
}

function* saveResourceSheet() {
  yield takeLatest(actions.SAVE_RESOURCE_SHEET, function* ({ payload }) {
    const {
      entries,
      holds,
      tasks,
      teamDoId,
      teamCheckId,
      resolve,
      reject,
    } = payload;
    try {
      const response = yield call(resourceSheetService.saveResourceSheet, {
        entries,
        holds,
        tasks,
        teamDoId,
        teamCheckId,
      });
      yield put({
        type: actions.SAVE_RESOURCE_SHEET_SUCCESS,
      });
      if (resolve) {
        yield resolve(response);
      }
    } catch (e) {
      yield put({ type: actions.SAVE_RESOURCE_SHEET_ERROR, error: e });
      if (reject) {
        reject(e);
      }
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getListResourceSheet),
    fork(appendResourceSheetWeek),
    fork(saveResourceSheet),
  ]);
}
